import Vue from 'vue';
import { State } from '@/stores/approvals/state';
import { MutationTree } from 'vuex';
import { Approval } from '@/models/approval';

export class Mutations implements MutationTree<State> {
    [key: string]: (state: State, payload: any) => any;

    public setAllApprovals = (state: State, Approvals: Array<Approval>) => {
        state.allApprovals = Approvals;
    }
    public setAllApprovalsPage = (state: State, page: number) => {
        state.allApprovalsPageNumber = page;
    }
    public setAllApprovalsCurrentPageSize = (state: State, pageSize: number) => {
        state.allApprovalsPageSize = pageSize;
    }
    public setAllApprovalsTotalPages = (state: State, pageCount: number) => {
        state.allApprovalsTotalPages = pageCount;
    }
    public setAllApprovalsTotal = (state: State, totalRecords: number) => {
        state.allApprovalsTotal = totalRecords;
    }
    public setAllApprovalsFilterStatus = (state: State, filterStatus: number | string | null) => {
        state.allApprovalsFilterStatus = filterStatus;
    }
    public setAllApprovalsFrom = (state: State, from: string | null) => {
        state.allApprovalsFrom = from;
    }
    public setAllApprovalsTo = (state: State, to: string | null) => {
        state.allApprovalsTo = to;
    }
}
